import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  dialog_head: {
    // display: "flex !important",
    width: "100%",
    // justifyContent: "space-between !important",
  },
  profile: {
    display: "flex",
    alignItems: "center",
    color: "black",
    width: '100%',
    "&:hover": {
      cursor: "pointer",
    },
  },
  profile_capt: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "10px",
    width: '100%'
  },
  profile_name: {
    whiteSpace: "nowrap",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '80%',
    fontSize: "16px",
  },
  profile_subdomain: {
    whiteSpace: "nowrap",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '80%',
    fontSize: "12px",
    marginTop: "-3px",
  },
  upvote: {
    padding: "9px 14px 4px 14px",
    backgroundColor: "white",
    color: "grey",
    border: "1px solid grey",
    borderRadius: "6px",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "whitesmoke",
      color: "black",
      border: "1px solid black",
    },
  },
  action_button: {
    display: "flex",
    alignItems: "center",
    justifyContent: 'right'
  },
  hero: {
    maxHeight: "510px",
    minHeight: "300px",
    objectFit: "scale-down",
    width: "100%",
  },
  dialog_content: {
    "@media (max-width: 768px)": {
      padding: 0,
    },
  },
  dialog_content_text: {
    marginTop: "20px",
    textAlign: "justify",
    "@media (max-width: 768px)": {
      paddingLeft: "16px",
      paddingRight: "16px",
    }
  },
  description_text: {
    whiteSpace: "pre-line",
    marginTop: '10px',
    color: 'black',
    "@media (max-width: 600px)": {
      lineHeight: '1.5rem'
    },
  }
}));

export default useStyles;
